/**
 * C7 stays hidden until SynAnalytics moves to synanalytics.co.za: build with
 * VITE_WHITE_LABEL=on to show White label settings, the agency portal address
 * and Log in with Google (the API has the matching WHITE_LABEL var).
 */
export const WHITE_LABEL_ON = import.meta.env.VITE_WHITE_LABEL === 'on';
